/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState } from 'react'
import './style.scss'

const scrollId = makeId()
const tableContextId = makeId()


const StepScrolling = ({ totalCount, pageSize, rowHeight, headerHeight,
    dataList, callGetData, currentPage, setDataListToDisplay, children,
    setPageNumber, pending = false, pageNumberFromPager }) => {

    const [isScrolling, setIsScrolling] = React.useState()
    const [scrollPosition, setScrollPosition] = React.useState()
    const [mainDataList, setMainDataList] = React.useState([]);
    const [contextHeight, setContextHeight] = React.useState(0)
    React.useEffect(() => {
        if (document.getElementById(scrollId)) {
            document.getElementById(scrollId)
                .addEventListener('scroll', scrolling, false);
        }

    }, [])

    React.useEffect(() => {
        initializeMainList();

    }, [])

    React.useEffect(() => {

        if (pageNumberFromPager?.pageNumber) {

            if (mainDataList.length > 0) {
                if (mainDataList.some(item => item.page === pageNumberFromPager.pageNumber)) {
                    const _dataList = mainDataList.find(item => item.page === pageNumberFromPager.pageNumber)
                    setDataListToDisplay([..._dataList.data])
                    setPageNumber(pageNumberFromPager.pageNumber)

                } else {
                    callGetData({ pageNumber: pageNumberFromPager.pageNumber })

                }

            }
        }
        if (document.getElementById("gsfTable")) {
            setContextHeight(document.getElementById("gsfTable").offsetHeight)
        }


    }, [pageNumberFromPager])

    React.useEffect(() => {
        if (mainDataList.length > 0 && dataList) {
            if (!mainDataList.some(item => item.page === currentPage)) {
                setDataListToDisplay([...dataList])
                let tempList = [...mainDataList]
                const pageHeight = (pageSize * rowHeight);
                let tempModel = {
                    data: [], page: currentPage, minScrollPosition: mainDataList[mainDataList.length - 1].maxScrollPosition,
                    maxScrollPosition: mainDataList[mainDataList.length - 1].maxScrollPosition + pageHeight
                }

                tempModel.data = dataList;
                tempList.push(tempModel);

                setMainDataList([...tempList])
                setPageNumber(currentPage)

            } else {
                let tempList = [...mainDataList]
                tempList.forEach(item => {
                    if (item.page === currentPage) {
                        if (item.data !== dataList) {
                            setDataListToDisplay([...dataList])
                            item.data = dataList

                        }
                    }
                })

                setMainDataList([...tempList])


            }

        }
        else {
            initializeMainList()
        }

    }, [dataList])

    React.useEffect(() => {

        if (scrollPosition !== undefined) {
            mainDataList.forEach(item => {
                if (scrollPosition > item.minScrollPosition && scrollPosition <= item.maxScrollPosition) {
                    if (item.data.length === 0) {
                        callGetData({ pageNumber: item.page })
                    } else {
                        setDataListToDisplay([...item.data])
                        setPageNumber(item.page)

                    }
                }
            })

            const pageHeight = (pageSize * rowHeight) * (mainDataList.length + 1);
            if ((Math.round(scrollPosition) + (pageSize * rowHeight)) === pageHeight) {
                callGetData({ pageNumber: currentPage + 1 })

            }
        }


    }, [scrollPosition])

    const initializeMainList = () => {
        if (mainDataList.length === 0 && dataList?.length > 0) {
            let tempList = []
            const pageHeight = (pageSize * rowHeight);
            // const pageHeight = contextHeight;

            let tempModel = {
                data: [], page: 1, minScrollPosition: 0, maxScrollPosition: pageHeight
            }

            tempModel.data = dataList;
            setDataListToDisplay([...dataList])
            setPageNumber(1)
            tempList.push(tempModel);

            setMainDataList([...tempList])
        }

    }

    const scrolling = () => {

        window.clearTimeout(isScrolling);
        const sPos = document.getElementById(scrollId).scrollTop;
        const _isScrolling = setTimeout(function () {
            if (sPos !== scrollPosition) {
                setScrollPosition(sPos)
            }

        }, 1000);
        setIsScrolling(_isScrolling)

    }
    const tableScrolling = (e) => {
        if (e.nativeEvent.wheelDeltaY < 0) {
            document.getElementById(scrollId).scrollTop = document.getElementById(scrollId).scrollTop + 50

        } else {
            if (document.getElementById(scrollId).scrollTop >= 50) {
                document.getElementById(scrollId).scrollTop = document.getElementById(scrollId).scrollTop - 50

            }
        }
        scrolling()

    }

    return (
        <div className='main-scroll-context'>

            <div className='table-table-container'>
                <div id={tableContextId} onWheel={tableScrolling} style={{ height: `${totalCount > pageSize ? ((pageSize * rowHeight) + headerHeight) + 'px' : 'unset'}` }}>{children}</div>
                {/* <div id={tableContextId} onWheel={tableScrolling} style={{ height: `${contextHeight + 'px'}` }}>{children}</div> */}

            </div>

            {totalCount > pageSize && <div id={scrollId} className="table-scroll" style={{ height: `${(pageSize * rowHeight) + headerHeight}px` }}>
                <div style={{ height: `${((mainDataList.length + 1) * pageSize * rowHeight) + headerHeight}px` }}></div>
            </div>}
            {pending && <div className='table-loading '>
                <div className="spinner-border" role="status" aria-hidden="true"></div>
            </div>}


        </div>

    )
}

export default StepScrolling


function makeId() {
    var text = "";
    var possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz";

    for (var i = 0; i < 5; i++)
        text += possible.charAt(Math.floor(Math.random() * possible.length));

    return text;
}

